import { useToastStore, type ToastItem, type ToastPosition } from '../../services/toastService'
import './Toast.css'

// Toast 图标组件
const ToastIcon = ({ type }: { type: ToastItem['type'] }) => {
  const icons = {
    success: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    error: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <path d="M15 9l-6 6M9 9l6 6" strokeLinecap="round" />
      </svg>
    ),
    warning: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" strokeLinecap="round" />
        <line x1="12" y1="17" x2="12.01" y2="17" strokeLinecap="round" />
      </svg>
    ),
    info: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4M12 8h.01" strokeLinecap="round" />
      </svg>
    ),
    loading: (
      <div className="toast-loading-spinner">
        <svg viewBox="0 0 50 50">
          <circle
            className="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="5"
          ></circle>
        </svg>
      </div>
    ),
  }

  return <span className={`toast-icon toast-icon-${type}`}>{icons[type]}</span>
}

// Toast 项组件
const ToastItemComponent = ({ toast }: { toast: ToastItem }) => {
  const removeToast = useToastStore((state) => state.removeToast)

  return (
    <div className={`toast-item toast-${toast.type} ${toast.stackable ? 'toast-stackable' : ''}`}>
      <ToastIcon type={toast.type} />
      <div className="toast-content">
        {toast.title && <div className="toast-title">{toast.title}</div>}
        <div className="toast-message">{toast.message}</div>
      </div>
      <button
        className="toast-close"
        onClick={() => removeToast(toast.id)}
        aria-label="关闭提示"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  )
}

// Toast 位置容器组件
const ToastPositionContainer = ({ position, toasts }: { position: ToastPosition; toasts: ToastItem[] }) => {
  if (toasts.length === 0) return null

  return (
    <div className={`toast-container toast-container-${position}`}>
      {toasts.map((toast) => (
        <ToastItemComponent key={toast.id} toast={toast} />
      ))}
    </div>
  )
}

// Toast 容器组件
export const ToastContainer = () => {
  const toasts = useToastStore((state) => state.toasts)

  if (toasts.length === 0) return null

  // 按位置分组
  const toastsByPosition = toasts.reduce((acc, toast) => {
    const position = toast.position || 'top-right'
    if (!acc[position]) {
      acc[position] = []
    }
    acc[position].push(toast)
    return acc
  }, {} as Record<ToastPosition, ToastItem[]>)

  return (
    <>
      {Object.entries(toastsByPosition).map(([position, positionToasts]) => (
        <ToastPositionContainer
          key={position}
          position={position as ToastPosition}
          toasts={positionToasts}
        />
      ))}
    </>
  )
}

export default ToastContainer
